var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-detail-header',{attrs:{"title":'Summary',"sub-title":''}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('appFilter')],1),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[_c('appResult')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/paywall/summary/Summary.vue